import React, { useState } from 'react';
import type { Condition } from '@util/insights/topSearchesNov2025';
import { suggestedAsk } from '@util/insights/topSearchesNov2025';

interface ConditionAdjusterProps {
  lowPrice: number;
  highPrice: number;
  skuId: string;
  onConditionChange?: (condition: Condition, suggestedPrice: number) => void;
}

export const ConditionAdjuster: React.FC<ConditionAdjusterProps> = ({
  lowPrice,
  highPrice,
  skuId,
  onConditionChange,
}) => {
  const [selectedCondition, setSelectedCondition] = useState<Condition>('G');

  const conditions: { value: Condition; label: string }[] = [
    { value: 'L', label: 'L' },
    { value: 'G', label: 'G' },
    { value: 'F', label: 'F' },
  ];

  const currentSuggestedAsk = suggestedAsk(lowPrice, highPrice, selectedCondition);

  const handleConditionChange = (condition: Condition) => {
    setSelectedCondition(condition);
    const suggested = suggestedAsk(lowPrice, highPrice, condition);
    onConditionChange?.(condition, suggested);
  };

  return (
    <div className="space-y-2">
      {/* Segmented control */}
      <div className="inline-flex rounded-md border border-gray-300 bg-white overflow-hidden">
        {conditions.map(({ value, label }) => (
          <button
            key={value}
            onClick={() => handleConditionChange(value)}
            className={`px-4 py-2 text-base font-medium transition-colors ${
              selectedCondition === value
                ? 'bg-gray-900 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-50'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Suggested ask */}
      <div className="text-base">
        <span className="text-gray-600">Suggested Ask:</span>{' '}
        <span className="font-semibold text-gray-900">
          ${currentSuggestedAsk.toLocaleString()}
        </span>
      </div>

      {/* Condition legend (for first use) */}
      <div className="text-sm text-gray-500 hidden md:block">
        L: Like New (+10%) · G: Good (median) · F: Fair (-12%)
      </div>
    </div>
  );
};
